import { SearchResponse } from "@/fetchInterceptor/AxiosMethod";
import {
  AttendeeInfo,
  IAttendeeInfoCompact,
  IAttendeeStatusRequest,
} from "./entity/AttendeeEntity";
import { MeetingDetails } from "../resource-service/entity/MeeingEntity";

export const TokenIAttendeeService = "IAttendeeService";
export interface IAttendeeService {
  getScheduleAttendee: (
    request: IAttendeeStatusRequest,
    mapAttendee: Record<string, IAttendeeInfoCompact>,
    isNextDate?: boolean
  ) => Promise<SearchResponse<AttendeeInfo>>;
  fetchMeetingDaysByMonth: (
    request: IAttendeeStatusRequest
  ) => Promise<SearchResponse<string>>;
  fetchMeetingByDate(
    request: IAttendeeStatusRequest,
    mapAttendee: Record<string, IAttendeeInfoCompact>
  ): Promise<SearchResponse<MeetingDetails>>;
}
